import { Button } from "@/components/ui/button";
import { InteractiveHoverButton } from "@/components/ui/interactive-hover-button";
import prismImage from "@/assets/prism.png";
import { useLanguage } from "@/contexts/LanguageContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { Calendar } from "lucide-react";

declare global {
  interface Window {
    Calendly: {
      initPopupWidget: (options: { url: string }) => void;
    };
  }
}

const CTASection = () => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const handleBookCall = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: 'https://calendly.com/cepulisedgaras/30min' });
    }
  };
  
  const handleExploreCourses = () => {
    navigate(user ? "/courses" : "/auth");
  };
  
  return (
    <section id="cta" className="min-h-screen py-20 md:py-32 px-4 md:px-6 flex items-center">
      <div className="container mx-auto max-w-7xl">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="space-y-6 md:space-y-8">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-glow-hover uppercase">
              <span className="block">{t("cta.ready")}</span>
              <span className="block text-outline">{t("cta.toTurn")}</span>
              <span className="block text-holographic">{t("cta.shape")}?</span>
            </h2>
            <p className="text-xl md:text-2xl font-bold text-glow-hover">{t("cta.growthNow")}</p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                size="lg"
                variant="holographic"
                className="font-bold text-base md:text-lg px-6 md:px-8 py-5 md:py-6 w-full sm:w-auto min-h-[44px] gap-2"
                onClick={handleBookCall}
              >
                <Calendar className="w-5 h-5" />
                {t("cta.bookCall")}
              </Button>
              <InteractiveHoverButton
                text={t("hero.exploreCourses")}
                onClick={handleExploreCourses}
                className="w-full sm:w-auto min-h-[44px]"
              />
            </div>
          </div>

          <div className="flex justify-center">
            <img
              src={prismImage}
              alt="Holographic Shape"
              className="w-full max-w-md animate-spin-glow"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
